"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _utils = require("../utils");
var _editorialXlCards = _interopRequireDefault(require("./editorial-xl-cards.props/editorial-xl-cards.defaultProps"));
var _editorialXlCards2 = _interopRequireDefault(require("./editorial-xl-cards.props/editorial-xl-cards.propTypes"));
var _editorialXlCards3 = _interopRequireDefault(require("../styles/editorial-xl-cards.css"));
var _card = _interopRequireDefault(require("./card"));
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var EditorialXlCards = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(EditorialXlCards, _React$Component);
  EditorialXlCards.resourceType = function resourceType() {
    return 'EditorialCards_1_0_0';
  };
  function EditorialXlCards(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.renderCards = _this.renderCards.bind((0, _assertThisInitialized2["default"])(_this));
    _this.xlCardsContainer = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      xlCardsContainer: null
    };
    return _this;
  }
  var _proto = EditorialXlCards.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$xlCardsContaine;
    if (((_this$xlCardsContaine = this.xlCardsContainer) == null ? void 0 : _this$xlCardsContaine.current) != null) {
      var _this$xlCardsContaine2;
      console.log('soy null');
      this.setState({
        xlCardsContainer: (_this$xlCardsContaine2 = this.xlCardsContainer) == null ? void 0 : _this$xlCardsContaine2.current
      });
    }
  };
  _proto.marginTopRemoved = function marginTopRemoved(columns) {
    var marginTopRemoved = false;
    columns.forEach(function (column) {
      if (column && column.description.noTopPaggingMobile) {
        marginTopRemoved = true;
      }
    });
    return marginTopRemoved;
  };
  _proto.renderCards = function renderCards(columns, theme, disclaimerData, isImageCard) {
    return columns && columns.map(function (card, i) {
      if (card) {
        return /*#__PURE__*/_react["default"].createElement(_card["default"], {
          isImageCard: isImageCard,
          key: i,
          data: card,
          theme: theme,
          disclaimerData: disclaimerData
        });
      }
      return '';
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData,
      isImageCard = _this$props.isImageCard;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var editorialLayout = componentData.editorialLayout,
      columns = componentData.columns,
      disclaimerData = componentData.disclaimerData;
    var marginTopRemoved = this.marginTopRemoved(columns);
    var fixTopMargin = marginTopRemoved ? _editorialXlCards3["default"].noTopMarginFirstChild : '';
    var xlCardsContainer = this.state.xlCardsContainer;
    if (editorialLayout === 'extralarge') {
      var _clsx;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.xlCardsContainer,
        className: (0, _clsx2["default"])(theme['container-fluid'] + " " + (isImageCard ? _editorialXlCards3["default"].containerImageWrapper : _editorialXlCards3["default"].wrapper), (_clsx = {}, _clsx[_editorialXlCards3["default"].hasTopTextBlock] = (0, _utils.isReducedTopSpace)(xlCardsContainer), _clsx[_editorialXlCards3["default"].hasBottomTextBlock] = (0, _utils.isReducedBottomSpace)(xlCardsContainer), _clsx), fixTopMargin)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row + " " + _editorialXlCards3["default"].row + " "
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-sm-1']
      }), this.renderCards(columns, theme, disclaimerData, isImageCard), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-sm-1']
      })));
    }
    return null;
  };
  return EditorialXlCards;
}(_react["default"].Component);
exports["default"] = EditorialXlCards;
EditorialXlCards.displayName = 'EditorialXlCards';
EditorialXlCards.defaultProps = {
  data: _editorialXlCards["default"],
  defaultData: _editorialXlCards["default"]
};